import React from 'react';
import PropTypes from 'prop-types';
import cancelIcon from '../../../assets/images/cancel.svg';
import "../../subComponents/buttons/button.css"

const CancelButton = ({ onClick, text, width }) => {
    const isRTL = document.body.dir === "rtl"
    const buttonStyle = {
        width: width || "88px",
        display: "flex",
        flexDirection: isRTL ? "row-reverse" : "row"
    }
    return (
        <button
            onClick={onClick}
            className="submit-cancel-button"
           style={buttonStyle}
        >
            {true && (
                <img 
                    src={cancelIcon} 
                    alt="Cancel Icon" 
                    style={{ width: '16px', height: '16px' }} 
                />
            )}
            {text}
        </button>
    );
};

CancelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
};

CancelButton.defaultProps = {
    text: 'Cancel',
};

export default CancelButton;
